export const BUTTON_CLICK_ANIMATION_DURATION = 100; // ms
